import React, { useContext, createContext, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useQuery } from '@apollo/react-hooks';
import { GET_SERVICE_TIMESLOTS } from '../../../../../network/queries';
import { PageContext } from '../../../context';

export const ContentContext = createContext({});
export const { ContentConsumer } = ContentContext;

export const ContentProvider = ({ children }) => {
  const context = useContext(PageContext);
  const { selectedService } = context;

  const [selectedDate, setSelectedDate] = useState(moment());

  const { loading: queryLoading, error: queryError, data: queryData } = useQuery(
    GET_SERVICE_TIMESLOTS,
    {
      variables: {
        serviceId: selectedService && selectedService.id,
        month: parseInt(moment(selectedDate).format('M'), 10),
        year: parseInt(moment(selectedDate).format('YYYY'), 10),
      },
    },
  );

  const getAvailableTimeSlots = () => {
    if (!queryData) return [];
    const {
      availableTimeSlots: { edges },
    } = queryData;
    const currentDay = edges.find(
      ({ day }) => day === parseInt(moment(selectedDate).format('D'), 10),
    );
    return currentDay ? currentDay.timeSlots : [];
  };

  const handleChangeDate = (newDate) => {
    if (moment(newDate).isValid()) {
      setSelectedDate(newDate);
    }
  };

  const contextData = {
    queryLoading,
    queryError,
    queryData,
    getAvailableTimeSlots,
    selectedDate: moment(selectedDate).format('MM/DD/YYYY'),
    handleChangeDate,
  };

  return <ContentContext.Provider value={{ contextData }}>{children}</ContentContext.Provider>;
};

ContentProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
